<template>
  <v-container>
    <v-card-title class="h1 justify-center">Cadastrar Controlador</v-card-title>
    <controlador-form @save="save" @close="$emit('close')" />
  </v-container>
</template>

<script>
import ControladorForm from '../_components/form/ControladorForm.vue'

import { computed } from './_computed'
import { methods } from './_methods'

export default {
  name: 'Cadastro',
  components: { ControladorForm },
  computed,
  methods,
  mounted() {
    this.RESET_CONTROLADOR()
  },
}
</script>
